import { ReactElement } from "react";

import SignInLayout from "@/components/Layouts/SignInLayout";
import { NextPageWithLayout } from "@/lib/types";
import { Loader } from "@/utils/Loader";
import { Flex } from "@chakra-ui/react";
import Head from "next/head";

const Index: NextPageWithLayout = () => {
  return (
    <>
      <Head>Loading...</Head>
      <Flex justifyContent="center" alignItems="center" h="100vh">
        {/* INDEX PAGE */}
        <Loader />
      </Flex>
    </>
  );
};

Index.getLayout = function getLayout(page: ReactElement) {
  return <SignInLayout>{page}</SignInLayout>;
};

export default Index;
